module.exports = __webpack_public_path__ + "static/media/kushner-egypt.b75043fb.webp";